module.exports = __webpack_public_path__ + "static/media/kfc-24-3.ce2fbba9.jpg";